import React from 'react';

export default function Kontak(){
  return (
    <main style={{padding:16}}>
      <h1>Kontak</h1>
      <p>Hubungi kami di (000) 000-000.</p>
    </main>
  );
}
